export enum RequestStatus {
	UNLOADED = 'unloaded',
	LOADING = 'loading',
	SUCCESS = 'success',
	ERROR = 'error',
	FORBIDDEN = 'forbidden',
	NOT_FOUND = 'not_found',
}
